import { DriverPreviousLicenceCheckDates } from "../../../../models/api/admin/driver";
import { CheckStatus } from "../../../../models/shared/statuses";
import { StatusAction } from "../../../ActionableStatus/ActionableStatus";
import { LicenceChecksActions } from "../licenceCheckActions";
import LicenceCheckStatus from "../LicenceCheckStatus";

type NoGbEntitlementLicenceCheckStatusProps = {
    driverId: string;
    isManual: boolean;
    lastCheckDate: string;
    nextCheckDate: string;
    previousLicenceCheckDates: DriverPreviousLicenceCheckDates;
    checkStatus: CheckStatus;
    buildActions: (actionNames: LicenceChecksActions[]) => StatusAction[];
};

const NoGbEntitlementLicenceCheckStatus = ({
    driverId,
    isManual,
    lastCheckDate,
    nextCheckDate,
    previousLicenceCheckDates,
    checkStatus,
    buildActions,
}: NoGbEntitlementLicenceCheckStatusProps) => {
    const actions = buildActions(
        isManual
            ? [
                  "editCheckDate",
                  "markAsChecked",
                  "markAsPending",
                  "markAsFailed",
                  "disableFurtherChecks",
                  "changeToAutomatic",
                  "previousLicenceCheckDates",
              ]
            : [
                  "editCheckDate",
                  "retryCheck",
                  "changeToManual",
                  "disableFurtherChecks",
                  "previousLicenceCheckDates",
              ]
    );

    return (
        <LicenceCheckStatus
            previousLicenceCheckDates={previousLicenceCheckDates}
            actions={actions}
            theme="vrm"
            text="No GB entitlement"
            driverId={driverId}
            isManual={isManual}
        >
            <span>Last check: {lastCheckDate}</span>
            <span>
                {checkStatus === CheckStatus.Disabled
                    ? "Further checks disabled"
                    : `Next check: ${nextCheckDate}`}
            </span>
        </LicenceCheckStatus>
    );
};

export default NoGbEntitlementLicenceCheckStatus;
